import React from 'react';
import { Link } from 'react-router-dom';

interface PublicConsentCheckboxProps {
  id: string;
  checked: boolean;
  purpose: string;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const PublicConsentCheckbox: React.FC<PublicConsentCheckboxProps> = ({
  id,
  checked,
  purpose,
  onChange,
  disabled = false,
  className = '',
}) => {
  const labelId = `${id}-label`;

  return (
    <div className={`public-consent ${className}`.trim()}>
      <input
        id={id}
        name={id}
        type="checkbox"
        required
        checked={checked}
        disabled={disabled}
        aria-labelledby={labelId}
        onChange={(event) => onChange(event.target.checked)}
      />
      <p id={labelId}>
        <label htmlFor={id}>I consent to {purpose} as described in the </label>
        <Link to="/privacy">Privacy Policy</Link>, and accept the{' '}
        <Link to="/terms">Terms and Conditions</Link>.
      </p>
    </div>
  );
};

export default PublicConsentCheckbox;
